import { SnapType } from 'types/snaps';

export const IMAGE_STAGE_CONFIG = {
  stageName: SnapType.IMAGE,
  properties: ['callToAction', 'lens'],
  transformToStaged: (properties: any) => properties,
  transformFromStaged: (properties: any) => properties,
};
